import state from "@/store/modules/acessibilidade/state";
import mutations from "@/store/modules/acessibilidade/mutations";
import getters from "@/store/modules/acessibilidade/getters";
import actions from "@/store/modules/acessibilidade/actions";

export default {
    state,
    mutations,
    getters,
    actions
}